import { storefrontClient } from "../../App";
import { getProductByHandle } from "../../queries/storefront-graphql";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { IProductsParamsProps, ProductPage } from "../../components/ProductPage"
import { ProductPageHeader } from "../../components/ProductPageHeader";
import { ProductPageDetails } from "@merchstores/frontend/components/ProductPageDetails";
import LoadingGif from "../../assets/common/Flask-3s-200px.svg";
import { IMerchStore, IStoreState, Scalar } from "@merchstores/frontend/reduxTypes";
import { shallowEqual, useSelector } from "react-redux";

export const ProductPageLayout = () => { // Define the actual props needed in the index file

    const { productHandle } = useParams<IProductsParamsProps>();
    const merchstore: IMerchStore = useSelector((state: IStoreState) => state.merchstore, shallowEqual)
    const history = useHistory();

    const [product, setProduct] = useState({ id: "", title: "", variants: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        storefrontClient.send(getProductByHandle(productHandle))
            .then(({ model }: any) => {
                if (model && model.productByHandle) {

                    const product = { ...model.productByHandle };
                    if (product && merchstore && product.tags) {
                        const isProductFromMerchstore = product.tags.find((t: Scalar) => t.value.includes(`merchstore_code=${merchstore.storeCode}`));
                        if (!isProductFromMerchstore) { // The product is from a different store, redirect to 404
                            console.log("The product is from a different store, redirect to 404");
                            history.push("/404");
                        }
                        setProduct(product);
                        setLoading(false);
                    } else {
                        console.log(`No product found with handle ${productHandle}`);
                        history.push("/404");
                    }

                } else {
                    console.log(`No product found with handle ${productHandle}`);
                    history.push("/404");
                }
            })

    }, [productHandle]);


    if (loading) {
        return <div className="h-screen flex items-center justify-center"><img src={LoadingGif} alt="loading flask" width="100px" /></div>
    }

    return (
        <>
            <ProductPageHeader product={product} />
            <ProductPage product={product} />
            <ProductPageDetails product={product} />
        </>
    )
}